import 'css-chunk:src/components/breadcrumb/breadcrumb-component.module.scss';export default {
  "container": "breadcrumb-component_container__7UXNd",
  "sep": "breadcrumb-component_sep__Pbiyz",
  "back-sep": "breadcrumb-component_back-sep__Li-XW",
  "back": "breadcrumb-component_back__SjXXk",
  "link-container": "breadcrumb-component_link-container__OvfIb",
  "link-contents": "breadcrumb-component_link-contents__N6p2K",
  "lte-tablet-visible": "breadcrumb-component_lte-tablet-visible__LzOZn",
  "link": "breadcrumb-component_link__dY-Ve"
};